import Loading from "@/components/shared/loading";
import ToastWrapper from "@/components/shared/toast-wrapper";
import { usePageLoading } from "@/components/shared/use-page-loading-hook";
import ErrorLogWrapper from "@/components/shared/wrappers/error-log-wrapper";
import { SessionProvider } from "next-auth/react";
import { Provider } from "react-redux";
import "../../public/css/globals.css";
import "../../public/css/react-toastify.css";
import "../i18n/index";
import { store } from "../redux/store";

export default function App({ Component, pageProps, session }) {
	const { is_page_loading } = usePageLoading();
	return (
		<>
			<noscript>
				Your browser does not support JavaScript or it is disabled. This site requires JavaScript
				for full functionality.
			</noscript>
			<ErrorLogWrapper>
				<Provider store={store}>
					<SessionProvider session={session}>
						<ToastWrapper>
							{is_page_loading ? <Loading /> : <Component {...pageProps} />}
						</ToastWrapper>
					</SessionProvider>
				</Provider>
			</ErrorLogWrapper>
		</>
	);
}
